import type { ExpressCheckoutAddress } from '@stripe/stripe-js';
import getUsStates, { caProvinces } from './usStates';

// the purchase's shipping-name rule: a letter first, then letters, spaces and ,.'- and two or more
const SHIPPING_NAME = /^\p{L}+[\p{L} ,.'-]*$/u;

export function isShippingName(value: string): boolean {
  return value.length >= 2 && SHIPPING_NAME.test(value);
}

/** drops the characters the shipping-name rule refuses (digits, emoji, brackets) and single-spaces */
export function cleanName(value: string): string {
  return value
    .replace(/[^\p{L} ,.'-]/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** the region code the purchase validates; a wallet returns the contact as typed, "Fl" or "Florida" */
export function toRegionCode(state: string, country: string): string {
  const trimmed = state.trim();
  const regions = country === 'US' ? getUsStates() : country === 'CA' ? caProvinces() : undefined;
  const match = regions?.find(
    (region) => region.abbreviation === trimmed.toUpperCase() || region.name.toLowerCase() === trimmed.toLowerCase(),
  );
  return match?.abbreviation ?? trimmed;
}

/** trims every line and puts the region and country in the codes the purchase expects */
export function sanitizeExpressAddress(address: ExpressCheckoutAddress): ExpressCheckoutAddress {
  const country = address.country.trim().toUpperCase();
  return {
    line1: address.line1.trim(),
    line2: address.line2?.trim() || null,
    city: address.city.trim(),
    state: toRegionCode(address.state, country),
    postal_code: address.postal_code.trim(),
    country,
  };
}
